const eventListenersToRemove = []

const removeRegisteredListeners = () => {
  eventListenersToRemove.forEach((listener) => listener())
}

const makeBuildDatepickerCallback =
  (buildDatepicker, formSubmit) => (datepickerCandidates) => {
    datepickerCandidates.forEach((element) => {
      const { execute, on: datepickerOn } = buildDatepicker(element, {
        orientation: 'bottom left',
      })

      const removeListener = datepickerOn('change', () => {
        execute('hide')
        const form = element.closest('form')
        formSubmit(form)
      })

      eventListenersToRemove.push(removeListener)
    })
  }

export default ({
  buildDatepicker,
  formSubmit,
  onDomLoad,
  onDocumentEvent,
} = {}) => {
  const buildDatepickerElements = makeBuildDatepickerCallback(
    buildDatepicker,
    formSubmit
  )

  const handleDatepickers = () => {
    removeRegisteredListeners()

    const datepickerCandidates = document.querySelectorAll(
      '[data-behaviour~="admin-ledger-date-picker"] input[type=text]'
    )

    buildDatepickerElements(datepickerCandidates)
  }

  onDomLoad(() => {
    handleDatepickers()
  })

  window.eventHub.$on('progress-checker:global-replace-html', handleDatepickers)

  const removeTurbolinksListener = onDocumentEvent(
    document,
    'turbolinks:before-visit',
    null,
    removeRegisteredListeners
  )

  return () => {
    removeTurbolinksListener()
    removeRegisteredListeners()

    window.eventHub.$off(
      'progress-checker:global-replace-html',
      handleDatepickers
    )
  }
}
